export default __webpack_public_path__ + "dfc9918a5ee8f0f699b2d8a65bea0405.png";